export default {

  handleFormValidation() {
    let oForm = $('#form-reloj-control');

    let aRules = {
      fecha_control: {required: true},
      hora_entrada: {
        required: true,
        minlength: 5,
        maxlength: 5,
      },
      hora_salida: {required: true},
      minutos_almuerzo: {required: true},
    };

    let aMessages = {
      fecha_control: {
        required: 'El campo Fecha es obligatorio.'
      },
      hora_entrada: {
        required: 'El campo Hora Entrada es obligatorio.',
        minlength: 'El campo Hora Entrada debe tener el formato hh:mm.',
        maxlength: 'El campo Hora Entrada debe tener el formato hh:mm.',
      },
      hora_salida: {
        required: 'El campo Hora Salida es obligatorio.',
        minlength: 'El campo Hora Salida debe tener el formato hh:mm.',
        maxlength: 'El campo Hora Salida debe tener el formato hh:mm.',
      },
      minutos_almuerzo: {
        required: 'El campo Minutos Almuerzo es obligatorio.'
      },
    };

    // Validación del formulario
    FormHelper.validate(oForm, aRules, aMessages);
  },

  initCombos() {
    $('.select2').select2({
      placeholder: "Seleccionar...",
      allowClear: true
    });
  },

  initDatePickers() {
    $('.js-datepicker').each((index, element) => {
      const startDate = $(element).data('start-date') || null;
      const endDate = $(element).data('end-date') || null;

      $(element).datepicker({
        orientation: "left",
        autoclose: true,
        format: 'dd/mm/yyyy',
        language: 'es',
        startDate: startDate,
        endDate: endDate,
      });
    });

  },

  initFormatTime() {
    $('.js-format-time').change(function () {
      $(this).val(FormHelper.formatTime($(this).val()));
    });
  },

  init() {
    this.handleFormValidation();
    this.initCombos();
    this.initDatePickers();
    this.initFormatTime();
  },

  initIndex() {
    this.initCombos();
    this.initDatePickers();
    FormHelper.handleSearch();
  },

  eliminar(form, nombre) {
    let mensaje = '<p>¿Realmente deseas eliminar el registro <strong>' + nombre + '</strong>?</p><p>La acci&oacute;n no podr&aacute; ser revertida.</p>';
    FormHelper.confirm(form, mensaje);
  },
};
